import { useState, useEffect } from "react";
import useQuery from "./useQuery";

export default function useTab(tabs = []) {
  const query = useQuery();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const tabIndex = Number(query.get("tab") || 0);
    setIndex(tabIndex);
  }, [query.search]);

  const change = (newIndex) => {
    if(newIndex < 0 || newIndex >= tabs.length) return;
    query.set("tab", newIndex);
  };

  return {
    index,
    setIndex,
    label: tabs[index],
    change,
  };
}
